import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { cutlistsApi } from '@/api/backend/cutlists';
import { Button } from '@/primitives/Button';
import { Input } from '@/primitives/Input';

import { ErrorMessage } from './ErrorMessage';
import { Modal } from './Modal';
import styles from './RequestUnauthQuoteFlow.module.css';

export const StarterLeadModal = ({
  cutlistId,
  isOpen,
  onClose,
}: {
  cutlistId: string;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'landing-page.starter-lead',
  });
  const [error, setError] = React.useState('');
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    const data = new FormData(e.currentTarget);
    const email = data.get('email') as string;
    const phone = (data.get('phone') as string) || undefined;

    cutlistsApi
      .saveStarterTierCutlist(cutlistId)
      .then(() => cutlistsApi.saveStarterTierLead(cutlistId, { email, phone }))
      .then(() => {
        toast.success(t('success'));
        onClose();
      })
      .catch(() => setError(t('error')))
      .finally(() => setIsSubmitting(false));
  };

  return (
    <Modal title={t('title')} isOpen={isOpen} handleClose={onClose}>
      <div className={styles.modalContent}>
        <p>{t('instructions')}</p>
        {Boolean(error) && <ErrorMessage message={error} />}
        <form className={styles.formContainer} onSubmit={onSubmit}>
          <div>
            <label htmlFor="starterLeadEmail">
              {t('email')} {'*'}
            </label>
            <Input
              id="starterLeadEmail"
              type="email"
              name="email"
              autoComplete="email"
              required
            />
          </div>
          <div>
            <label htmlFor="starterLeadPhone">{t('phone')}</label>
            <Input
              id="starterLeadPhone"
              type="tel"
              name="phone"
              autoComplete="tel"
            />
          </div>
          <Button
            type="submit"
            name="submitStarterLead"
            disabled={isSubmitting}
          >
            {t('submit')}
          </Button>
        </form>
      </div>
    </Modal>
  );
};
